import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const isOpen = (treatmentObjcts, exps) => {
  const date = new Date();
  const dayOfTheWeek = date.getDay();
  const weekNum = dayOfTheWeek;
  const nowOpen = treatmentObjcts.some((treatmentObjct)=>{
    const time = treatmentObjct.time;
    const timeRange = time.split('-').map(t => t.split(':'));
    const operation = treatmentObjct.operation;
    const beforeRange = Number(timeRange[0][0]) < date.getHours() || (Number(timeRange[0][0]) == date.getHours() && Number(timeRange[0][1]) < date.getMinutes());
    const afterRange = Number(timeRange[1][0]) > date.getHours() || (Number(timeRange[1][0]) == date.getHours() && Number(timeRange[1][1]) > date.getMinutes());
    // console.log(timeRange, beforeRange, afterRange, operation[weekNum]);
    if (operation[weekNum] == '●') {
      return beforeRange && afterRange;
    } else if (operation[weekNum] != '休' || operation[weekNum] != '×') {
      const exeption = [].some.call(exps, function(exp){
        const limitTime = exp.limit.split(':')
        return Number(limitTime[0]) > date.getHours() || (Number(limitTime[0]) == date.getHours() && Number(limitTime[1]) > date.getMinutes());
      });
      return beforeRange && afterRange && exeption;
    }
    return false;
  });
  // console.log('isopen:',nowOpen);
  return nowOpen;
};

export default new Vuex.Store({
  state: {
    isMobile: /iPhone|iPad|Android/.test(navigator.userAgent),
    isOpen: isOpen(siteData.detail.treatment, siteData.detail.treatment_detail.exceptions),
    siteData: siteData
  },
  mutations: {

  },
  actions: {
    smoothScroll (context, opt = {}) {
      const duration = opt.duration ? opt.duration : 500
      const stopPos = opt.scrollPos ? opt.scrollPos : 0;
      let count = 0;
      let posY = window.scrollY;
      let distance = Math.floor((posY - parseInt(stopPos))/100);
      window.scrollTo(0, posY - posY%100);
      posY -= posY%100;
      var timer = setInterval(function(){
        window.scrollTo(0, posY - (distance));
        posY -= distance;
        count = count + 1;
        if(count == 100) clearInterval(timer);
      }, duration/100);
    }
  }
})
